import React from 'react';

import PageLoading from 'src/components/PageLoading';
import { AxiosHeaders } from 'axios';
import { client } from 'src/utils/api-client';

interface Props {
  children: React.ReactNode;
  tokenFetcher: () => Promise<string | undefined>;
}

export default function Qv3AuthProvider(props: Readonly<Props>) {
  const { tokenFetcher } = props;
  const [interceptorReady, setInterceptorReady] = React.useState(false);
  const [tokenReady, setTokenReady] = React.useState(false);

  React.useEffect(() => {
    // Add a request interceptor to add the token to the headers
    const interceptor = client.interceptors.request.use(async (config) => {
      // Add the token to the headers if the URL contains a api-questionnaires
      if (config.url?.includes('api-questionnaires'))
        config.headers = new AxiosHeaders({
          ...config.headers,
          'X-Questionnaires-Token': (await tokenFetcher()) || 'token-required',
        });
      return config;
    });
    setInterceptorReady(true);
    return () => {
      client.interceptors.request.eject(interceptor);
    };
  }, []);

  React.useEffect(() => {
    // Fetch the token initially once (so the queries dont have to)
    tokenFetcher().then(() => setTokenReady(true));
  }, []);

  if (!interceptorReady || !tokenReady) return <PageLoading />;
  return props.children as React.ReactElement;
}
